import React from 'react';
import App from "../App";
import './../assets/fonts/scss/fonts.scss'
import './../assets/scss/themes/brown_theme.scss'

class BrownTheme extends React.Component {
    render() {
        return (
            <App PCBID={this.props.PCBID} color={this.props.color}/>
        )
    }
}

export default BrownTheme;